import type { JSONNode } from "./schema";

const isObject = (v: unknown): v is Record<string, any> => !!v && typeof v === "object";

/** Accepts: an array of nodes, a `{ type: "doc", content: [...] }` document, or a single node. */
function coerceToNodeArray(input: unknown): JSONNode[] {
  if (Array.isArray(input)) return input;
  if (isObject(input)) {
    if (Array.isArray(input.content)) return input.content;
    if (typeof input.type === "string") return [input as JSONNode];
  }
  return [];
}

/**
 * Recursively visits every node in raw (non-live-editor) TipTap `Content` JSON, including nested
 * children, calling `visit(node)` for each. `visit` may mutate `node.attrs` in place if the caller
 * needs to rewrite content (e.g. migration) — this function does not transform or return anything
 * itself, it's a plain visitor.
 */
export function walkContentNodes(content: unknown, visit: (node: JSONNode) => void): void {
  for (const node of coerceToNodeArray(content)) {
    if (!isObject(node)) continue;
    visit(node);
    if (Array.isArray(node.content)) walkContentNodes(node.content, visit);
  }
}
